function updateRecommendationResponse (pack_type, pack, pack_description) {

  const filter_output = document.getElementById('water-filter');
  let recommend_tpl = '',
  alkaline_tpl = pack_type == 'alkaline' ? `If you don't need to reduce limescale build-up, we recommend` : `We recommend`;

  if (pack_type) {
    recommend_tpl = `<div class="recommend-container pack-${pack_type}">
      <p>${alkaline_tpl}</p>
      <h3>${pack.title}</h3>
        <div class="recommend-content grid grid--uniform grid--flush-bottom">
        <div class="recommend-image grid__item medium-up--one-half">
          <a href="/products/${pack.handle}/">
            <img src="${pack.featured_image}" alt="${pack.title}">
          </a>
        </div>
        <div class="recommend-description grid__item medium-up--one-half">
          <div>${pack_description}</div>
          <a href="/products/${pack.handle}/" class="recommend-btn">Get yours now!</a>
        </div>
      </div>
    </div>`;
  } else {
    recommend_tpl = '';
  }

  filter_output.innerHTML = recommend_tpl;
}

function addSpaceAsFourthChar(str) {
  str = str.trim();

  // Check if the string has at least 4 characters
  if (str.length < 4) {
      return str; // No change needed
  }

  // Get the fourth character from the right
  const fourthCharFromRight = str[str.length - 4];

  // Check if it is not a space
  if (fourthCharFromRight !== ' ') {
      // Insert a space as the fourth character from the right
      const modifiedString = str.slice(0, -3) + ' ' + str.slice(-3);
      return modifiedString;
  }

  // No change needed
  return str;
}

function submitPostcodeForm(event) {
  let postcode = addSpaceAsFourthChar(document.getElementById('postcode').value),
      line = document.getElementById('wavy-line'),
      water_scale = document.getElementById('water-scale'),
      submit_btn = document.getElementById('postcode-submit'),
      limeScaleQuestion = document.getElementById('lime-scale-question'),
      limeScaleYes = document.getElementById('lime-scale-yes'),
      limeScaleNo = document.getElementById('lime-scale-no'),
      url = api_url + '?postcode=' + encodeURIComponent(postcode),
      xhr = new XMLHttpRequest();

  limeScaleQuestion.style.display = 'none';

  xhr.responseType = 'json';
  xhr.open('GET', url, true);
  xhr.onload = function() {
    const hardness_threshold = 100;
    let response = xhr.response,
        output = document.getElementById('postcode-response');

    if (response.status) {
      if (response.status == 'success') {
        let hardness = response.data.hardness,
            water_type = 'Agressively hard water',
            water_class = 'agressively-hard';
            recommend_tpl = '';

        gtag('event', 'waterHardness', {
          'eventCategory': "Button Click",
          'eventAction': "Click",
          'eventLabel': "Hardness Lookup",
          'postcode_found': true,
          'postcode': postcode
        });

        // define the water type for the scale
        if (hardness == 0) {
          water_class = false;
        } else if (hardness < 50) {
          water_type = 'Soft water';
          water_class = 'soft';
        } else if (hardness < 100) {
          water_type = 'Moderately soft water';
          water_class = 'moderately-soft';
        } else if (hardness < 150) {
          water_type = 'Slightly hard water';
          water_class = 'slightly-hard';
        } else if (hardness < 200) {
          water_type = 'Moderately hard water';
          water_class = 'moderately-hard';
        } else if (hardness < 300) {
          water_type = 'Hard water';
          water_class = 'hard';
        } else if (hardness < 350) {
          water_type = 'Very hard water';
          water_class = 'very-hard';
        }

        // Output the water area
        if (hardness > 0) {
          if (response.data.water_authority) {
            if (response.data.region) {
              output.innerHTML = `<p>We can see that your water provider in ${response.data.region} is</p><div class="provider">${response.data.water_authority}</div><p>which has</p><div class="water-type">${water_type}</div>`;
            } else {
              output.innerHTML = `<p>We can see that your water provider is</p><div class="provider">${response.data.water_authority}</div><p>which has</p><div class="water-type">${water_type}</div>`;
            }
          } else {
            if (response.data.region) {
              output.innerHTML = `<p>We can see that your water supplier in ${response.data.region} has</p><div class="water-type">${water_type}</div>`;
            } else {
              output.innerHTML = `<p>We can see that your water supplier has</p><div class="water-type">${water_type}</div>`;
            }
          }
        } else {
          if (response.data.region) {
            output.innerHTML = `<p>We couldn't find a rating for your water provider in ${response.data.region}`;
          } else {
            output.innerHTML = `<p>We couldn't find a rating for your water provider in your area.`;
          }
        }

        // Update the scale needle
        if (water_class) {
          water_scale.classList.add(water_class);
        }

        if (hardness > 60) {  
          limeScaleQuestion.style.display = 'block';

          if (hardness >= 200) {
            updateRecommendationResponse ('softener', softener_pack, softener_pack_description);

            limeScaleYes.addEventListener('change', function () {
              updateRecommendationResponse ('softener', softener_pack, softener_pack_description);
            });
            limeScaleNo.addEventListener('change',  function () {
              updateRecommendationResponse ('alkaline', alkaline_pack, alkaline_pack_description);
            });
          } else {
            updateRecommendationResponse ('clean', clean_pack, clean_pack_description);

            limeScaleYes.addEventListener('change', function () {
              updateRecommendationResponse ('clean', clean_pack, clean_pack_description);
            });
            limeScaleNo.addEventListener('change', function () {
              updateRecommendationResponse ('alkaline', alkaline_pack, alkaline_pack_description);
            });
          } 
        } else {
          updateRecommendationResponse ('alkaline', alkaline_pack, alkaline_pack_description)
        }        
      } else {
        // Post code not found
        gtag('event', 'waterHardness', {
          'eventCategory': "Button Click",
          'eventAction': "Click",
          'eventLabel': "Hardness Lookup",
          'postcode_found': false,
          'postcode': postcode
        });

        output.innerHTML = '<div class="response-error">Post code not found</div>';
        updateRecommendationResponse();
      }
    } else {
      output.innerHTML = '<div class="response-error">' + response + '</div>';
    }

    submit_btn.innerHTML = '➔';
    submit_btn.disabled = false;
    line.classList.remove('animating');
  };
  
  xhr.onerror = function(res) {
    let output = document.getElementById('postcode-response'),
        line = document.getElementById('wavy-line');
    output.innerHTML = 'Error finding post code.';
    line.classList.remove('animating');
    updateRecommendationResponse();
  };

  xhr.send();
}
  
window.addEventListener('load', function() {
  const postcodeForm = document.getElementById('postcode-form');
  
  postcodeForm.addEventListener('submit', function (event) {
    event.preventDefault();
    let line = document.getElementById('wavy-line'),
        water_scale = document.getElementById('water-scale'),
        submit_btn = document.getElementById('postcode-submit');

    line.classList.add('animating');
    submit_btn.disabled = true;
    submit_btn.innerHTML = '<div class="loader"></div>';
    water_scale.classList.remove('soft', 'moderately-soft', 'slightly-soft', 'moderately-hard', 'hard', 'very-hard', 'agressively-hard');
    
    setTimeout(function() {
        submitPostcodeForm(event);
    }, 1200)
  });

  const urlParams = new URLSearchParams(window.location.search);
  const postcode = urlParams.get('postcode');

  if (postcode) {
    document.getElementById('postcode').value = postcode,
    submitPostcodeForm();
  }
});